import * as listItemTypes from '../../UI/List/ListItem/ListItemTypes';
import * as screenSize from '../../../model/ScreenSize/ScreenSize';

const extraFields = (currentScreenSize) => {

	const width = {
		[screenSize.DESKTOP]: 111,
		[screenSize.TABLET]: 78,
		[screenSize.ERROR]: 0,
	}[currentScreenSize];

	const maxWidth = {
		[screenSize.DESKTOP]: 166,
		[screenSize.TABLET]: 136,
		[screenSize.ERROR]: 0,
	}[currentScreenSize];

	const height = {
		[screenSize.DESKTOP]: 35,
		[screenSize.TABLET]: 45,
		[screenSize.ERROR]: 0,
	}[currentScreenSize];

	return [
		{
			key: 'name',
			label: 'Name',
			order: 1,
			width,
			maxWidth,
			height,
			type: listItemTypes.TEXT,
		},
		{
			key: 'description',
			label: 'Description',
			order: 2,
			pinned: true,
			width,
			maxWidth,
			height,
			type: listItemTypes.TEXT,
		},
		{
			key: 'value',
			label: 'Value',
			order: 3,
			pinned: true,
			width,
			maxWidth,
			height,
			type: listItemTypes.TEXT,
		},
		{
			key: 'createDate',
			label: 'Create Date',
			order: 4,
			pinned: true,
			width,
			maxWidth,
			height,
			type: listItemTypes.TEXT,
		},
		{
			key: 'enabled',
			label: 'Enabled',
			order: 5,
			pinned: true,
			width,
			maxWidth,
			height,
			type: listItemTypes.COMPONENT,
		},
		{
			key: 'editIcons',
			label: 'Actions',
			order: 99,
			pinned: true,
			width,
			maxWidth,
			height,
			type: listItemTypes.COMPONENT,
			flexDirection: 'row-reverse',
		},
	];
};

export default extraFields;